import { jsx as _jsx } from "react/jsx-runtime";
import { CustomIcon } from 'console/shared/components/icon/custom';
import { SwipeDown, SwipeUp } from '@mui/icons-material';
import { motion } from 'framer-motion';
import { useAppSelector } from 'shared/hooks/redux/hooks';
export function UiGuidesUtils(props) {
    const { up } = props;
    const step_key = useAppSelector((state) => state.ui_guide_state.learning.current_step_key);
    if (up && step_key != 'show_more_info') {
        return null;
    }
    if (!up && step_key != 'close_change_temp_modal') {
        return null;
    }
    return (_jsx(motion.div, { style: {
            position: 'absolute',
            fontSize: '7rem',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%,-50%)',
            zIndex: 2,
        }, animate: { top: up ? '15%' : '75%' }, transition: { repeat: Infinity, duration: 1.5 }, children: _jsx(CustomIcon, { Icon: up ? SwipeUp : SwipeDown, color: "info" }) }));
}
